import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import {
	getSettingsResourceSearchFilters,
	renderSettingsResourceLabel,
} from "../../../../../utils/helpers/settings";

export const useCalculationGroupFilter = () => {
	const { t } = useTranslation();

	return useMemo(
		() => ({
			id: "calculationGroup",
			Header: t("calculation-group"),
			filter: "resource-select",
			canFilter: true,
			Filter: (
				<ResourceSelect
					labelPropName="description"
					renderLabel={renderSettingsResourceLabel}
					resourcePath="/calculation-group"
					hasSearch
					mode="multiple"
					getSearchFilters={getSettingsResourceSearchFilters}
				/>
			),
		}),
		[t],
	);
};
